import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_fac_failing_to_comply_w_any_legal_reqs_for_contracts_and'

export const dataPointDefinition = {
  retracedId: 'is_the_fac_failing_to_comply_w_any_legal_reqs_for_contracts_and',
  name: 'Is the facility failing to comply with any legal requirements for Contracts and Hiring Practices pertaining to non-production workers and/or onsite sub-contracted workers?',
  description:
    'Answer No if the facility is complying with all legal requirements on Contracts and Hiring Practices pertaining to non-production workers and/or onsite sub-contracted workers.\r\r\n\r\r\nUse this question to record any non-compliance with legal requirements when the non-compliance pertains to non-production workers and/or onsite sub-contracted workers (who are not covered in the rest of the tool, unless specifically noted).\r\r\n\r\r\nExamples of non-production workers and/or onsite sub-contracted workers are security, cleaning, and canteen staff.\r\r\n\r\r\nDo NOT also record the non-compliance under other more specific questions on Contracts and Hiring Practices when the non-compliance relates ONLY to non-production workers and/or onsite sub-contracted workers. ',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-emp-8',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6290,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
